import { render, staticRenderFns } from "./DataTableLoader.vue?vue&type=template&id=689e8f11&scoped=true"
import script from "./DataTableLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataTableLoader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DataTableLoader.vue?vue&type=style&index=0&id=689e8f11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e8f11",
  null
  
)

export default component.exports